import {
    createContext,
    useContext,
    type ComponentProps,
    type ReactNode,
} from "react";
import { NavigationDropdown } from "@design-system/NavigationDropdown/NavigationDropdown";
import { SideNavPickerTrigger } from "@design-system/SideNav/SideNavPickerTrigger";

interface PickerIdentity {
    avatar: ReactNode;
    label: ReactNode;
}

const PickerIdentityContext = createContext<PickerIdentity>({
    avatar: null,
    label: "",
});

type PickerTriggerProps = Omit<
    ComponentProps<typeof SideNavPickerTrigger>,
    "avatar" | "label"
>;

/** Takes the menu trigger's props and ref from `NavigationDropdown`; the identity comes from context so this type stays stable. */
const PickerTrigger = (props: PickerTriggerProps) => {
    const { avatar, label } = useContext(PickerIdentityContext);

    return <SideNavPickerTrigger avatar={avatar} label={label} {...props} />;
};

/** A level's switcher: today's dropdown body behind the side nav's picker trigger. */
export const SideNavMenuPicker = ({
    avatar,
    label,
    children,
}: PickerIdentity & { children: ReactNode }) => (
    <PickerIdentityContext.Provider value={{ avatar, label }}>
        <NavigationDropdown toggle={PickerTrigger}>
            {children}
        </NavigationDropdown>
    </PickerIdentityContext.Provider>
);
